import './PricePod.scss';

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import useCardView from '../../../hooks/useCardView';
import GENERAL_TRANSLATIONS from '../../../translations/translations@default.json';
import {
	currencyFormatter,
	savingsPercentage,
} from '../../../utilities/number-utilities';
import TRANSLATIONS from './translations@default.json';

const formatter = currencyFormatter(GENERAL_TRANSLATIONS.general);

const SaveWasContainer = ({ was, save, displayWasPrice }) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isGridView, isListView } = useCardView();

	return (
		<div
			className={classnames('flex text-body-xs', {
				'lg:justify-end': !isDealsPage && isListView,
				'xl:flex-col': !isDealsPage && isGridView,
				'lg:flex-row-reverse': isDealsPage && isListView,
			})}>
			<div
				className={classnames('font-bold text-deals', {
					'lg:ml-1': isDealsPage && isListView,
				})}>
				{!isDealsPage || (isDealsPage && save >= 100) ? (
					<React.Fragment>
						{TRANSLATIONS.save}{' '}
						<span data-testid="price-save">{formatter.format(save)}</span>
					</React.Fragment>
				) : (
					<React.Fragment>
						{TRANSLATIONS.saving}{' '}
						<span data-testid="price-percentage">
							{savingsPercentage(was, save)}
						</span>
					</React.Fragment>
				)}
			</div>
			<div
				className={classnames({
					'text-tertiary ml-2': !isDealsPage,
					'xl:ml-0': !isDealsPage && isGridView,
					'ml-2 md:ml-1': isDealsPage,
				})}>
				{displayWasPrice ? TRANSLATIONS.was : TRANSLATIONS.RRP}{' '}
				<span data-testid={displayWasPrice ? 'price-was' : 'price-rrp'}>
					{formatter.format(was)}
				</span>
			</div>
		</div>
	);
};

const PricePod = ({
	classes,
	viewModel: {
		NowPrice,
		WasPrice,
		SavePrice,
		RetailPriceIncVat,
		RetailPriceSavings,
	} = {},
}) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isListView } = useCardView();

	if (!NowPrice) {
		return null;
	}

	const dealAvailable = SavePrice > 0 || RetailPriceSavings > 0;

	const displayWasPrice = WasPrice > 0 && SavePrice > 0;

	const was = displayWasPrice ? WasPrice : RetailPriceIncVat;
	const save = displayWasPrice ? SavePrice : RetailPriceSavings;

	return (
		<div
			className={classnames(classes, {
				'mt-2 md:mt-0': !isDealsPage,
				'flex flex-col mb-1': isDealsPage,
				'lg:justify-end': isDealsPage && isListView,
			})}>
			<div
				className={classnames({
					'text-deals': dealAvailable,
					'text-display-lg': isDealsPage,
					'text-title-lg': !isDealsPage,
					'lg:text-title-lg': isDealsPage && isListView,
				})}
				data-testid="price-now">
				{formatter.format(NowPrice)}
			</div>

			{was > 0 && save > 0 && (
				<SaveWasContainer {...{ was, save, displayWasPrice }} />
			)}
		</div>
	);
};

export default PricePod;
